import { render, staticRenderFns } from "./OneCameSettingDialog.vue?vue&type=template&id=31bbe2cb&scoped=true"
import script from "./OneCameSettingDialog.vue?vue&type=script&lang=js"
export * from "./OneCameSettingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bbe2cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31bbe2cb')) {
      api.createRecord('31bbe2cb', component.options)
    } else {
      api.reload('31bbe2cb', component.options)
    }
    module.hot.accept("./OneCameSettingDialog.vue?vue&type=template&id=31bbe2cb&scoped=true", function () {
      api.rerender('31bbe2cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/OneCameSettingDialog.vue"
export default component.exports